import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

interface DiscardDraftDialogProps {
  open: boolean
  discarding: boolean
  refusal?: string
  onClose: () => void
  onConfirm: () => void
}

/**
 * Confirm before a draft is thrown away.
 *
 * Discarding also releases the draft's TPA plan mapping, so the plan id becomes claimable by
 * another configuration — which is the point when a draft is abandoned, and the reason this is
 * worth a confirmation rather than a single click.
 */
export const DiscardDraftDialog = ({
  open,
  discarding,
  refusal,
  onClose,
  onConfirm,
}: DiscardDraftDialogProps) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
    <DialogTitle>Discard this draft?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        The draft and everything entered on it are removed, and its plan id is released for another
        configuration to claim. This cannot be undone.
      </DialogContentText>
      {refusal && (
        <Alert severity="error" sx={{ mt: 2 }} data-testid="discard-refusal">
          {refusal}
        </Alert>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Keep editing</Button>
      <Button
        color="error"
        variant="contained"
        onClick={onConfirm}
        disabled={discarding}
        data-testid="discard-confirm"
      >
        Discard draft
      </Button>
    </DialogActions>
  </Dialog>
)
